import { RegionCreate } from './RegionCreate';
import { RegionEdit } from './RegionEdit/RegionEdit';
import { RegionList } from './RegionList/RegionList';
import { RegionShow } from './RegionShow/RegionShow';

export const create = RegionCreate;
export const edit = RegionEdit;
export const list = RegionList;
export const show = RegionShow;
